import styled from '@emotion/styled';
import _ from 'lodash';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';
import CardHalf from 'src/components//cards/card-half';
import { IMAGE_SIZE } from 'src/components/image';
import { IDataLayerGlobal } from 'src/interface/data-layer';
import { IArticle } from 'src/interface/section';
import useResponsive from 'src/utils/devices';

const SectionHeader = dynamic(import('src/components/sections/section-header'));
const CardHNoImage = dynamic(import('src/components/cards/card-h-no-img'));
const CardH = dynamic(import('src/components/cards/card-h'));
const Carousels = dynamic(import('src/components/carousels'));

type Props = {
  className?: string;
  lastNews?: IArticle[];
  heading?: string;
  eventDataLayer?: IDataLayerGlobal;
  path?: string;
  external?: boolean;
  size?: any;
  showImage?: boolean;
  carousel?: boolean;
  bgColor?: string;
  publishedAtKey?: 'published_at' | 'updated_at';
  target?: string;
};

const WidgetNews: NextPage<Props> = ({ className = '', lastNews, target = '', heading, eventDataLayer, external = false, showImage = false, carousel = false, bgColor = null }) => {
  if (_.isEmpty(lastNews)) return null;

  const responsive = useResponsive();
  return (
    <WidgetWrapper className='widget-news' bgColor={bgColor}>
      {responsive.isLaptop && (
        <div className='desktop'>
          <SectionHeader data={heading} showReadmore={false} className={`${className}`} />
          <div className='card-list'>
            {lastNews?.map((item: any, index: any) => (
              <div key={index} className='card-item'>
                {showImage && (
                  <CardH
                    className='card-lastnews'
                    data={item}
                    path={`/galleries/${item.id}`}
                    target={target}
                    size={IMAGE_SIZE.MD}
                    showBlurb={false}
                    external={external}
                    // ! DATALAYER
                    eventDataLayer={{
                      ...eventDataLayer,
                      data: {
                        title: item?.title,
                        index: index + 1,
                        ...eventDataLayer?.data
                      }
                    }}
                  />
                )}
                {!showImage && (
                  <CardHNoImage
                    className='card-lastnews'
                    data={item}
                    path={`/galleries/${item.id}`}
                    size={IMAGE_SIZE.MD}
                    showBlurb={false}
                    external={external}
                    // ! DATALAYER
                    eventDataLayer={{
                      ...eventDataLayer,
                      data: {
                        title: item?.title,
                        index: index + 1,
                        ...eventDataLayer?.data
                      }
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      {responsive.isMobile && (
        <>
          <div className='mobile'>
            {carousel ? (
              <>
                <SectionHeader data={heading} showReadmore={false} className='contnet' />
                <div className='card-list'>
                  <Carousels infinite={false} showArrow={true}>
                    {lastNews?.map((item: any, index: any) => (
                      <div key={index} className='card-item'>
                        {showImage && (
                          <CardHalf
                            color='#FFF'
                            className='card-lastnews'
                            data={item}
                            path={`/galleries/${item.id}`}
                            size={IMAGE_SIZE.MD}
                            showBlurb={false}
                            external={external}
                            showFooter={false}
                            // ! DATALAYER
                            eventDataLayer={{
                              ...eventDataLayer,
                              data: {
                                title: item?.title,
                                carousel: index + 1,
                                ...eventDataLayer?.data
                              }
                            }}
                          />
                        )}
                        {!showImage && (
                          <CardHNoImage
                            className='card-lastnews'
                            data={item}
                            path={`/galleries/${item.id}`}
                            size={IMAGE_SIZE.MD}
                            showBlurb={false}
                            external={external}
                            // ! DATALAYER
                            eventDataLayer={{
                              ...eventDataLayer,
                              data: {
                                title: item?.title,
                                carousel: index + 1,
                                ...eventDataLayer?.data
                              }
                            }}
                          />
                        )}
                      </div>
                    ))}
                  </Carousels>
                </div>
              </>
            ) : (
              <>
                <SectionHeader data={heading} showReadmore={false} className={className} />
                <div className='card-list'>
                  {lastNews?.map((item: any, index: any) => (
                    <div key={index} className='card-item'>
                      {showImage && (
                        <CardH
                          className='card-lastnews'
                          data={item}
                          path={`/galleries/${item.id}`}
                          size={IMAGE_SIZE.MD}
                          showBlurb={false}
                          external={external}
                          // ! DATALAYER
                          eventDataLayer={{
                            ...eventDataLayer,
                            data: {
                              title: item?.title,
                              index: index + 1,
                              ...eventDataLayer?.data
                            }
                          }}
                        />
                      )}
                      {!showImage && (
                        <CardHNoImage
                          className='card-lastnews'
                          data={item}
                          path={`/galleries/${item.id}`}
                          size={IMAGE_SIZE.MD}
                          showBlurb={false}
                          external={external}
                          // ! DATALAYER
                          eventDataLayer={{
                            ...eventDataLayer,
                            data: {
                              title: item?.title,
                              index: index + 1,
                              ...eventDataLayer?.data
                            }
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </>
      )}
    </WidgetWrapper>
  );
};

export default WidgetNews;

const WidgetWrapper = styled.div<{
  bgColor?: string | null;
}>`
  background-color: ${({ bgColor }) => bgColor || '#fff'};
  position: relative;
  overflow: hidden;
  .card-list {
    display: grid;
    grid-gap: 15px;
    padding-top: 15px;

    @media (max-width: 690px) {
      display: block;
      .card-item {
        padding-bottom: 8px;
      }
    }
  }
  .section-header {
    margin-bottom: 0;
  }
  .card-item {
    .card-h-img {
      .header h3 {
        font-weight: 300;
        -webkit-line-clamp: 3;
      }
    }
  }
`;
